import { createApp } from "vue";

import SportactiviteitBestel from "./SportactiviteitBestel.vue";
import FloatingVue from 'floating-vue'
import { getPinia } from "@/shared/pinia";
import Notifications from '@kyvg/vue3-notification';
import velocity from "velocity-animate";

const mountElement = document.querySelector("#sportactiviteit-bestel");

if (mountElement) {
    const app = createApp(SportactiviteitBestel);
    app.use(FloatingVue, {
        themes: {
            'payment-info': {
                $extend: 'tooltip',
            },
        },
    })

    app.use(Notifications, { velocity });
    app.use(getPinia());
    app.mount("#sportactiviteit-bestel");
}
